import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/caosconfiguration/template/apply";

export class ApplyTemplateCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: ApplyTemplateReqData;

    constructor(payload: ApplyTemplateReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

export class ApplyTemplateReqData {
    installationNames: Array<string>;
    templateId: number;
    constructor(other: string[], templateId: number) {
        this.installationNames = other;
        this.templateId = templateId;
    }
}
